import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Layout } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ClientNew = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    birth_date: "",
    notes: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/clients`, formData);
      toast.success("Cliente cadastrado com sucesso!");
      navigate(`/clients/${response.data.id}`);
    } catch (error) {
      toast.error("Erro ao cadastrar cliente");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="p-6 md:p-12 max-w-2xl" data-testid="client-new-page">
        {/* Header */}
        <button
          onClick={() => navigate("/clients")}
          className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8"
          data-testid="back-button"
        >
          <ArrowLeft size={16} />
          Voltar
        </button>

        <div className="mb-8">
          <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-2">
            Novo Cliente
          </p>
          <h1 className="font-serif text-3xl">Cadastrar cliente</h1>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="form-section">
            <h3 className="form-section-title">Dados Pessoais</h3>
            
            <div className="space-y-4">
              <div>
                <Label className="label-mono">Nome completo *</Label>
                <Input
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="input-paper"
                  placeholder="Nome do cliente"
                  required
                  data-testid="name-input"
                />
              </div>

              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <Label className="label-mono">Email</Label>
                  <Input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="input-paper"
                    placeholder="email@exemplo.com"
                    data-testid="email-input"
                  />
                </div>
                <div>
                  <Label className="label-mono">Telefone</Label>
                  <Input
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="input-paper"
                    placeholder="(00) 00000-0000"
                    data-testid="phone-input"
                  />
                </div>
              </div>

              <div>
                <Label className="label-mono">Data de nascimento</Label>
                <Input
                  type="date"
                  value={formData.birth_date}
                  onChange={(e) => setFormData({ ...formData, birth_date: e.target.value })}
                  className="input-paper"
                  data-testid="birth-date-input"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3 className="form-section-title">Observações</h3>
            <Textarea
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              placeholder="Anotações gerais sobre o cliente..."
              rows={4}
              data-testid="notes-input"
            />
          </div>

          <div className="flex gap-4 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={() => navigate("/clients")}
              className="btn-secondary flex-1"
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              disabled={loading}
              className="btn-primary flex-1"
              data-testid="submit-button"
            >
              {loading ? "Salvando..." : "Cadastrar"}
            </Button>
          </div>
        </form>
      </div>
    </Layout>
  );
};

export default ClientNew;
